const styles = (theme) => ({
  wrap: {
    display: 'flex',
    overflow: 'hidden',
    fontSize: '0.7rem',
    justifyContent: 'space-between'
  },
  categories: {
    // width: '68%'
  },
  addCategories: {
    width: '30%'
  },
  
});

export default styles;
